import axios from '@/api/http';
import base from '@/api//base';
const system = {
	// 分页查询字典数据
	SysDictDataPage(params){
		return axios.post(`${base.baseURL}/SysDictData/page`,params);
	},
	// code查询字典数据
	SysDictDataSelectList(code){
		return axios.get(`${base.baseURL}/SysDictData/selectList?dictTypeCode=${code}`);
	},
	// 添加字典数据
	insertNewParam(params){
		return axios.post(`${base.baseURL}/SysDictData/insert`,params);
	},
	// 修改字典数据
	updateParam(params){
		return axios.post(`${base.baseURL}/SysDictData/update`,params);
	},
	// 删除字典数据
	SysDictDatadelete(params){
		return axios.post(`${base.baseURL}/SysDictData/delete`,params);
	},
	// 分页查询字典类型
	SysDictTypePageType(params){
		return axios.post(`${base.baseURL}/SysDictType/page`,params);
	},
	// 添加字典类型
	insertParamType(params){
		return axios.post(`${base.baseURL}/SysDictType/insert`,params);
	},
	// 编辑字典类型
	updateParamType(params){
		return axios.post(`${base.baseURL}/SysDictType/update`,params);
	},
	// 删除字典类型
	SysDictTypedelete(params){
		return axios.post(`${base.baseURL}/SysDictType/delete`,params);
	},
	
	// 所有菜单构建树
	SysMenubuildTree(){
		return axios.get(`${base.baseURL}/SysMenu/buildTree`);
	},
	// 用户菜单构建树
	SysMenuBuildTreeByUserId(){
		return axios.get(`${base.baseURL}/SysMenu/buildTreeByUserId`);
	},
	// 新增菜单
	SysMenuInsert(params){
		return axios.post(`${base.baseURL}/SysMenu/insert`, params);
	},
	// 修改菜单
	SysMenuUpdate(params){
		return axios.post(`${base.baseURL}/SysMenu/update`, params);
	},
	// 角色Id菜单构建树
	SysMenuBbuildTreeByRoleId(roleId){
		return axios.get(`${base.baseURL}/SysMenu/buildTreeByRoleId/${roleId}`);
	},
	// 删除菜单
	SysMenuDelete(params){
		return axios.post(`${base.baseURL}/SysMenu/delete`, params);
	},
	
	
	// 角色列表
	SysRoleListPage(params){
		return axios.post(`${base.baseURL}/SysRole/page`, params);
	},
	// 新增角色
	SysRoleIinsert(params){
		return axios.post(`${base.baseURL}/SysRole/insert`, params);
	},
	// 修改角色
	SysRoleIUpdate(params){
		return axios.post(`${base.baseURL}/SysRole/update`, params);
	},
	// 禁用
	SysRoleRoleIdEnabled(params){
		return axios.post(`${base.baseURL}/SysRole/${params.roleId}/enabled/${params.enabled}`, params);
	},
	// 角色分配菜单
	SysRoleRroleIdAssignmentMenu(params){
		return axios.post(`${base.baseURL}/SysRole/${params}/AssignmentMenu`, [params]);
	},
	// 删除角色
	SysRoleDelete(params){
		return axios.post(`${base.baseURL}/SysRole/delete`, params);
	},
	// 分配角色
	SysRoleAssignment(params){
		return axios.post(`${base.baseURL}/SysRole/${params.roleId}/Assignment/${params.userId}`, params);
	},
	SysRoleCancelByUserId(userId){
		return axios.post(`${base.baseURL}/SysRole/cancel/${userId}`);
	},
	// 获取部门构建树
	DemisaRsBmJbxxbuildTree(){
		return axios.post(`${base.baseURL}/Demisa/RsBmJbxx/buildTree`);
	},
	// 所有部门构建树
	SysDepartmentBuildTree(){
		return axios.get(`${base.baseURL}/SysDepartment/buildTree`);
	},
	// 部门下构建树
	SysDepartmentBuildTreeDown(id){
		return axios.get(`${base.baseURL}/SysDepartment/selectListBuildTree?id=${id}`);
	},
	// 所有部门构建树-----select
	SysDepartmentBuildTreeFormsel(){
		return axios.get(`${base.baseURL}/SysDepartment/selectListBuildTree`);
	},
	// 新增部门
	SysDepartmentInsert(params){
		return axios.post(`${base.baseURL}/SysDepartment/insert`,params);
	},
	// 修改部门
	SysDepartmentUpdate(params){
		return axios.post(`${base.baseURL}/SysDepartment/update`,params);
	},
	// 删除部门
	SysDepartmentDelete(id){
		return axios.post(`${base.baseURL}/SysDepartment/delete`,id);
	},
	
	// 分页请求所有用户数据
	SysUserPage(params){
		return axios.post(`${base.baseURL}/SysUser/page`,params);
	},
	// 所有用户数据
	SysUserPageFormsel(params){
		return axios.post(`${base.baseURL}/SysUser/selectList`,params);
	},
	// 当前部门下用户数据
	SysUserPageFormselById(deptId){
		if(deptId){
			return axios.get(`${base.baseURL}/SysUser/selectListByDeptId?deptId=${deptId}`);
		}else{
			return axios.get(`${base.baseURL}/SysUser/selectListByDeptId`);
		}
	},
	// 修改用户的部门
	SysDepartmentUpdateUserDept(params){
		return axios.get(`${base.baseURL}/SysDepartment/updateUserDept?id=${params.id}&deptId=${params.deptId}`);
	},
	// 新增用户
	SysUserInsert(params){
		return axios.post(`${base.baseURL}/SysUser/insert`,params);
	},
	// 修改用户
	SysUserUpdate(params){
		return axios.post(`${base.baseURL}/SysUser/update`,params);
	},
	// 用户禁用或启用
	SysUserUpdateEnabledById(params){
		return axios.get(`${base.baseURL}/SysUser/updateEnabled/${params.id}/${params.enabled}`);
	},
	// 删除用户
	SysUserDeleteById(id){
		return axios.post(`${base.baseURL}/SysUser/delete`,id);
	},
	// 用户修改密码
	SysUserUpdatePassword(params){
		return axios.post(`${base.baseURL}/SysUser/updatePassword?id=${params.id}&newPassword=${params.newPassword}&oldPassword=${params.oldPassword}`,params);
	},
	// 重置用户密码
	SysUserResetPassword(id,type){
		return axios.post(`${base.baseURL}/SysUser/resetPassword?id=${id}&type=${type}`);
	},
	// 用户在职或离职
	SysUserUpdateJobStatusById(params){
		return axios.get(`${base.baseURL}/SysUser/updateJobStatus/${params.id}/${params.jobStatus}`);
	},
	// 系统日志
	SysLogPage(params){
		return axios.post(`${base.baseURL}/SysLog/page`,params);
	},
	// 文件管理
	SysFilePage(params){
		return axios.post(`${base.baseURL}/SysFile/page`,params);
	},
	// 删除文件
	SysFileDeleteById(id){
		return axios.post(`${base.baseURL}/SysFile/delete/${id}`);
	},
	
	
	// 上传文件-七牛云
	loadVideo(file) {
		return axios.post(`${base.baseURL}/SysFile/qiNiuUpload`,file)
	},
	// 获取Token-七牛云
	SysFileGetToken(params){
		return axios.get(`${base.baseURL}/SysFile/getToken`);
	},
}
export default system;



// WEBPACK FOOTER //
// ./src/network/system.js